import { images } from '../constants';

const services = [
    {
        id: 1,
        image: images.service1,
        title: 'Roof Installation',
        content: 'Expert installation of new roofing systems tailored to your home’s unique needs, ensuring unmatched durability and long-lasting longevity.',
        paragraphs: [
            'Protect your property with our professional roof installation services. We specialize in installing various types of roofing materials, including asphalt shingles, metal roofing, tile roofing, and more, to ensure durability and aesthetic appeal.',
            'Our experienced roofers are committed to delivering precision and quality in every project. Whether you\'re constructing a new building or replacing an old roof, our installation services provide the perfect balance of functionality and style.'
        ],
        gallery: [
            images.service1Gallery1,
            images.service1Gallery2
        ],
        features: [
            'Experienced Roofing Professionals',
            'High-Quality Roofing Materials',
            'Comprehensive Site Inspection',
            'Customized Roofing Solutions',
            'Long-Lasting Durability'
        ],
        procedure: [
            'Initial Consultation & Roof Assessment',
            'Material Selection & Planning',
            'Professional Installation & Finishing',
            'Quality Inspection & Approval',
            'Final Touches & Site Clean-Up'
        ],
        faqs: [
            {
                id: 1,
                heading: 'What types of roofing materials do you install?',
                content: 'We install a variety of roofing materials, including asphalt shingles, metal roofing, tile roofing, and more. Our team will guide you in selecting the best roofing option for your property based on your needs and budget.'
            },
            {
                id: 2,
                heading: 'Do you offer roof removal services?',
                content: 'Yes, we provide roof removal services as part of our comprehensive roof installation package. Our team will safely remove your old roof before installing the new one.'
            },
            {
                id: 3,
                heading: 'How long does the roof installation process take?',
                content: 'The time required for roof installation depends on the size and complexity of the project, as well as the type of roofing material. We strive to complete installations efficiently while maintaining high standards of quality.'
            },
            {
                id: 4,
                heading: 'Do you offer warranties on your roof installations?',
                content: 'Yes, we offer warranties on our roof installations to ensure your peace of mind. Our goal is to provide long-lasting roofing solutions that protect your property for years to come.'
            }
        ]
    },
    {
        id: 2,
        image: images.service2,
        title: 'Roof Repair',
        content: 'Comprehensive repair services to quickly fix leaks, damaged shingles, and other persistent roof issues promptly and effectively.',
        paragraphs: [
            'Don’t let minor roof problems turn into major headaches. Our expert roof repair services address leaks, missing or damaged shingles, water stains, and structural issues with precision and care.',
            'Using top-grade materials and proven techniques, we restore your roof’s integrity and extend its lifespan. Our goal is to protect your property from further damage and save you costly future repairs.'
        ],
        gallery: [
            images.service2Gallery1,
            images.service2Gallery2
        ],
        features: [
            'Fast Leak Detection',
            'Shingle Replacement & Repair',
            'Flashing & Sealant Fixes',
            'Storm & Wind Damage Repair',
            'Preventive Maintenance Services'
        ],
        procedure: [
            'Roof Assessment & Problem Identification',
            'Damage Documentation & Planning',
            'Targeted Repairs & Fixes',
            'Material Matching & Sealing',
            'Final Inspection & Clean-Up'
        ],
        faqs: [
            {
                id: 1,
                heading: 'What are common signs that my roof needs repair?',
                content: 'Common signs include water leaks, missing or curled shingles, moss growth, sagging areas, and visible damage after a storm.'
            },
            {
                id: 2,
                heading: 'How long does a typical roof repair take?',
                content: 'Most roof repairs can be completed within a few hours to a day, depending on the extent of the damage and weather conditions.'
            },
            {
                id: 3,
                heading: 'Can you match existing roofing materials during repair?',
                content: 'Yes, we carefully match existing materials to maintain your roof’s visual appeal and structural consistency.'
            },
            {
                id: 4,
                heading: 'Do you offer emergency roof repair services?',
                content: 'Absolutely. We offer emergency repair services to address urgent roofing issues and prevent further damage to your property.'
            }
        ]
    },
    {
        id: 3,
        image: images.service3,
        title: 'Roof Inspection',
        content: 'Thorough inspections to assess the condition of your roof and provide detailed reports with maintenance recommendations.',
        paragraphs: [
            'Ensure the health of your roofing system with our comprehensive roof inspection services. We meticulously examine every component of your roof to identify signs of damage, wear, or potential issues.',
            'From detecting hidden leaks to evaluating material performance, our detailed inspections give you a clear understanding of your roof’s condition and help you plan timely maintenance or repairs.'
        ],
        gallery: [
            images.service3Gallery1,
            images.service3Gallery2
        ],
        features: [
            'Comprehensive Roof Assessments',
            'Leak & Moisture Detection',
            'Damage & Deterioration Reports',
            'Preventive Maintenance Planning',
            'Professional Recommendations'
        ],
        procedure: [
            'Initial Consultation & Scheduling',
            'On-Site Roof Inspection',
            'Documentation of Findings',
            'Report Generation with Photos',
            'Maintenance or Repair Suggestions'
        ],
        faqs: [
            {
                id: 1,
                heading: 'How often should I get my roof inspected?',
                content: 'It’s recommended to have your roof inspected at least once a year, and after severe weather events like storms or heavy snowfall.'
            },
            {
                id: 2,
                heading: 'What does your roof inspection include?',
                content: 'Our inspection covers shingles, flashing, gutters, vents, structural components, and signs of leaks or damage.'
            },
            {
                id: 3,
                heading: 'Will I receive a written report?',
                content: 'Yes, we provide a detailed inspection report that includes images, observations, and recommendations for maintenance or repairs.'
            },
            {
                id: 4,
                heading: 'Is your inspection service available for commercial properties?',
                content: 'Absolutely. We offer roof inspection services for both residential and commercial buildings of all sizes.'
            }
        ]
    },
    {
        id: 4,
        image: images.service4,
        title: 'Gutter Installation',
        content: 'Professional gutter installation to protect your home’s foundation, roof, and overall structure from potential water damage.',
        paragraphs: [
            'Safeguard your home from costly water damage with our expert gutter installation services. We install high-quality gutter systems that efficiently channel rainwater away from your property.',
            'Our team ensures proper slope, secure fittings, and customized designs that match your home’s exterior while enhancing its protection against erosion, leaks, and structural issues.'
        ],
        gallery: [
            images.service4Gallery1,
            images.service4Gallery2
        ],
        features: [
            'Durable Gutter Materials',
            'Custom Fit & Design',
            'Efficient Water Drainage',
            'Seamless Installation',
            'Foundation & Roof Protection'
        ],
        procedure: [
            'On-Site Assessment & Measurements',
            'Material Selection & Planning',
            'Custom Fabrication (if required)',
            'Professional Installation',
            'Testing & Final Adjustments'
        ],
        faqs: [
            {
                id: 1,
                heading: 'Why are gutters important for my home?',
                content: 'Gutters prevent water from accumulating near your home’s foundation, reducing the risk of erosion, leaks, and structural damage.'
            },
            {
                id: 2,
                heading: 'What types of gutters do you install?',
                content: 'We install a variety of gutter types including aluminum, copper, vinyl, and seamless systems customized to your needs.'
            },
            {
                id: 3,
                heading: 'How long does gutter installation take?',
                content: 'The installation typically takes one day, depending on the size and complexity of the system.'
            },
            {
                id: 4,
                heading: 'Do you offer gutter guards or covers?',
                content: 'Yes, we offer optional gutter guards to help keep debris out and minimize cleaning requirements.'
            }
        ]
    },
    {
        id: 5,
        image: images.service5,
        title: 'Roof Replacement',
        content: 'Complete roof replacement services using premium, high-quality materials for a roof that will last for decades.',
        paragraphs: [
            'Upgrade your home’s protection with our comprehensive roof replacement services. Whether your roof is aged, severely damaged, or showing signs of frequent issues, we provide a reliable solution tailored to your needs.',
            'We use only premium materials and proven techniques to ensure long-lasting durability, enhanced curb appeal, and complete peace of mind with every new roof installation.'
        ],
        gallery: [
            images.service5Gallery1,
            images.service5Gallery2
        ],
        features: [
            'Premium Roofing Materials',
            'Old Roof Removal',
            'Expert Installation Team',
            'Weather-Resistant Solutions',
            'Extended Warranty Coverage'
        ],
        procedure: [
            'Initial Roof Inspection & Consultation',
            'Material Selection & Planning',
            'Tear-Off of Existing Roofing',
            'New Roof Installation',
            'Final Inspection & Cleanup'
        ],
        faqs: [
            {
                id: 1,
                heading: 'When should I consider a roof replacement?',
                content: 'If your roof is over 20 years old, shows extensive damage, or requires frequent repairs, a full replacement may be the best long-term solution.'
            },
            {
                id: 2,
                heading: 'What types of roofs do you replace?',
                content: 'We replace a variety of roofing systems including asphalt shingles, metal roofing, tile roofing, and more.'
            },
            {
                id: 3,
                heading: 'How long does a roof replacement take?',
                content: 'Roof replacement projects usually take a few days, depending on the size and type of your roof.'
            },
            {
                id: 4,
                heading: 'Do you handle old roof disposal?',
                content: 'Yes, our team removes and disposes of your old roofing materials as part of the replacement process.'
            }
        ]
    },
    {
        id: 6,
        image: images.service6,
        title: 'Skylight Installation',
        content: 'Enhance natural lighting in your home with expert, professional skylight installation services tailored to your needs.',
        paragraphs: [
            'Brighten up your living space with our professional skylight installation services. We specialize in fitting energy-efficient and aesthetically pleasing skylights that increase natural light and improve ventilation.',
            'Our team ensures proper placement and sealing to prevent leaks, maximize energy savings, and enhance the overall ambiance of your home.'
        ],
        gallery: [
            images.service6Gallery1,
            images.service6Gallery2
        ],
        features: [
            'Natural Light Enhancement',
            'Energy-Efficient Skylight Options',
            'Leak-Proof Installation',
            'Custom Placement Solutions',
            'Improved Ventilation'
        ],
        procedure: [
            'Initial Consultation & Roof Assessment',
            'Skylight Type Selection',
            'Cutting & Framing Preparation',
            'Professional Skylight Installation',
            'Final Sealing & Quality Check'
        ],
        faqs: [
            {
                id: 1,
                heading: 'What types of skylights do you install?',
                content: 'We install fixed, ventilated, tubular, and custom skylights to suit your space, style, and lighting needs.'
            },
            {
                id: 2,
                heading: 'Will a skylight increase my home’s energy efficiency?',
                content: 'Yes, modern skylights are designed to reduce the need for artificial lighting and can help lower energy costs when installed properly.'
            },
            {
                id: 3,
                heading: 'Do skylights leak over time?',
                content: 'When installed by professionals, skylights are properly sealed and flashed to prevent leaks and ensure long-term durability.'
            },
            {
                id: 4,
                heading: 'Can I choose where the skylight will be placed?',
                content: 'Absolutely! We work with you to determine the best location for optimal light distribution and functionality.'
            }
        ]
    }
];

export default services;